import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  modalAltText: {
    id: 'adminPortal.assignmentModal.altText',
    defaultMessage: 'More information',
  },
  modalTooltipText: {
    id: 'adminPortal.assignmentModal.tooltipText',
    defaultMessage: 'edX will remind learners to redeem their code 3, 10, and 19 days after you assign it.',
  },
  modalFieldLabel: {
    id: 'adminPortal.assignmentModal.modalFieldLabel',
    defaultMessage: 'Automate reminders',
  },
});

export default messages;
